import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReturnIcon from '@mui/icons-material/AssignmentReturnOutlined';
import DiscountIcon from '@mui/icons-material/LocalOfferOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';


const styles = {
    heading: {
        marginLeft: 2,
        color: '#3f51b5', // Initial color
        transition: 'color 0.3s ease',
        '&:hover': {
            color: '#ff4081', // Color on hover
        },
    },
};


const Banner = () => {
    return (
        <Grid container spacing={2} sx={{ backgroundColor: '#a2cf6e', padding: '20px 20px' }}>
            <Grid item xs={12} sm={6} md={3}>
                <Box className="service-cell" sx={{ backgroundColor: '#e3f2fd', padding: '20px', borderRadius: 4, margin: '0 10px', border: '1px solid #b3e5fc' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <LocalShippingOutlinedIcon sx={{ fontSize: 48, color: '#2196f3' }} />
                        <Typography variant="h5" sx={styles.heading}>Free Delivery</Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#666', mt: 1, ml: 8 }}>Orders from all items</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Box className="service-cell" sx={{ backgroundColor: '#e3f2fd', padding: '20px', borderRadius: 4, margin: '0 10px', border: '1px solid #b3e5fc' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <ReturnIcon sx={{ fontSize: 48, color: '#f44336' }} />
                        <Typography variant="h5" sx={styles.heading}>Return & Refund</Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#666', mt: 1, ml: 8 }}>Money back guarantee</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Box className="service-cell" sx={{ backgroundColor: '#e3f2fd', padding: '20px', borderRadius: 4, margin: '0 10px', border: '1px solid #b3e5fc' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <DiscountIcon sx={{ fontSize: 48, color: '#4caf50' }} />
                        <Typography variant="h5" sx={styles.heading}>Member Discount</Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#666', mt: 1, ml: 8 }}>On order over ₹99</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <Box className="service-cell" sx={{ backgroundColor: '#e3f2fd', padding: '20px', borderRadius: 4, margin: '0 10px', border: '1px solid #b3e5fc' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <SupportAgentOutlinedIcon sx={{ fontSize: 48, color: '#ff9800' }} />
                        <Typography variant="h5" sx={styles.heading}>Support 24/7</Typography>
                    </Box>
                    <Typography variant="body1" sx={{ color: '#666', mt: 1, ml: 8 }}>Contact us 24 hours a day</Typography>
                </Box>
            </Grid>
        </Grid>
    );
};

export default Banner;
